@import 'styles/mixins';
@import 'styles/variables';

.header {
  @include xxl-semibold;
  padding: 16px 20px 0 20px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: $grey-90;
  .icon {
    height: 28px;
    width: 28px;
    padding: 6px;
    > * {
      fill: var(--action-50);
    }
  }
}

.messageField {
  padding: 0;
  align-items: start;
  display: block;

  :global(.ProseMirror) {
    min-height: 92px;
  }
}

.description {
  @include lg-regular;
  margin: 0;
  color: var(--neutral-90);
  white-space: pre-line;
  margin-bottom: 16px;
}
